export default __webpack_public_path__ + "static/media/index.df1fdd75.less";